import { useEffect } from "react";
import { useLocation } from "react-router";

type Location = ReturnType<typeof useLocation>;

export const useOnLocationChange = (cb: (newLocation: Location) => void) => {
  const location = useLocation();

  // We don't want to trigger this because cb has changed, only when location has changed
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => cb(location), [location.pathname]);
};
